import { closingAttorneyContactCard, insertIntoArray } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const GAOverrides: ListingLocaleOverrides = {
  locale: 'GA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Deed Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
          },
        },
        mlsInformationCard: {
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.filter(
                    (prop) => prop.from !== 'property.legalDescription',
                  ),
              },
            },
          },
        },
        importantDatesCard: {
          layout: () => [
            [
              {
                name: 'contractDate',
                size: 33,
              },
              {
                name: 'listingStartDate',
                size: 33,
              },
              {
                name: 'listingEndDate',
                size: 33,
              },
            ],
            [
              {
                name: 'onMarketDate',
                size: 33,
              },
              {
                name: 'closingDate',
                size: 33,
              },
              {
                name: 'bindingAgreementDate',
                size: 33,
              },
            ],
          ],
          fields: {
            bindingAgreementDate: {
              name: 'bindingAgreementDate',
              entity: 'interaction',
              type: 'date',
              label: 'Binding Agreement Date',
              placeholderText: '',
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAgentCard: {
          action: (action) => ({
            ...action,
            props: action.props.filter(
              ({ from }) => from !== 'brokerageMlsCode',
            ),
          }),
          layout: (layout) =>
            insertIntoArray(layout, 5, [
              {
                name: 'contacts.agent.x.brokerage.mlsCode',
                size: 100,
              },
            ]),
          fields: {
            firstName: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'brokerage.mlsCode',
                      to: 'contacts.agent.x.brokerage.mlsCode',
                    },
                  ]),
              },
            },
            brokerageMlsCode: {
              name: 'contacts.agent.x.brokerage.mlsCode',
              entity: 'contacts',
              entityType: 'agent',
              type: 'text',
              label: 'Brokerage MLS Code',
              placeholderText: '',
              disabledForIndex: 0,
            },
          },
        },
      },
    },
    buyerSideContacts: {
      cards: {
        buyersAgentCard: {
          layout: (layout) =>
            insertIntoArray(layout, 5, [
              {
                name: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
                size: 100,
              },
            ]),
          fields: {
            firstName: {
              action: {
                props: (props) =>
                  props.concat([
                    {
                      from: 'brokerage.mlsCode',
                      to: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
                    },
                  ]),
              },
            },
            brokerageMlsCode: {
              name: 'contacts.counterpartyAgent.x.brokerage.mlsCode',
              entity: 'contacts',
              entityType: 'counterpartyAgent',
              type: 'text',
              label: 'Brokerage MLS Code',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => closingAttorneyContactCard,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: (options) => [
                {
                  label: 'Closing Attorney',
                  value: 'additionalContacts.closingAttorney',
                },
                ...options.slice(1),
              ],
            },
          },
        },
      },
    },
  },
};
